module.exports = __webpack_public_path__ + "img/click_btn.27d9c7f0.png";